import { render, staticRenderFns } from "./categoriemodale.vue?vue&type=template&id=335b8ce2&scoped=true"
import script from "./categoriemodale.vue?vue&type=script&lang=js"
export * from "./categoriemodale.vue?vue&type=script&lang=js"
import style0 from "./categoriemodale.vue?vue&type=style&index=0&id=335b8ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335b8ce2",
  null
  
)

export default component.exports